/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */

import { Observable, Observer } from "rxjs";
import { AxiosSubscriber } from "./AxiosSubscriber";

import { HTTP_METHOD } from "@nf/constants";
import { ILocalesResponseModel } from "../models";

export class LocalizationService {
  get url(): string {
    return "/v3";
  }

  public locales = (): Observable<ILocalesResponseModel> =>
    new Observable(
      (observer: Observer<ILocalesResponseModel>) =>
        new AxiosSubscriber(observer, {
          method: HTTP_METHOD.GET,
          url: `${this.url}/locales`,
        })
    );
}
